import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React from "react";
import {
  ChangeHandler,
  FieldError,
  FieldErrorsImpl,
  Merge,
  RefCallBack,
} from "react-hook-form";

interface DateFormInputProps {
  value: any;
  onChange: ChangeHandler;
  onBlur: ChangeHandler;
  ref: RefCallBack;
  name: string;
  label?: string;
  disabled?: boolean;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
}

const DateFormInput: React.FC<DateFormInputProps> = ({
  value,
  onChange,
  ref,
  name,
  label,
  error,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setIsOpen((isOpen) => !isOpen);
    setAnchorEl(event.currentTarget);
  };

  return (
    <DatePicker
      value={value}
      inputFormat="DD/MM/YYYY"
      open={isOpen}
      onClose={() => setIsOpen(false)}
      onChange={(newValue: dayjs.Dayjs | null) => {
        onChange({
          target: {
            name,
            value: newValue,
          },
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          value={params.value}
          name={name}
          label={label}
          inputRef={ref}
          disabled={disabled}
          sx={{
            width: "100%",
            ...(error
              ? {
                  "& .MuiInputBase-root > fieldset.MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "secondary.main",
                    },
                }
              : {
                  "& .MuiInputBase-root > fieldset.MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "grey[300]",
                    },
                }),
          }}
        />
      )}
      OpenPickerButtonProps={{
        onClickCapture: (e) => {
          e.stopPropagation();
          handleClick(e);
        },
      }}
      disabled={disabled}
      PopperProps={{
        placement: "bottom-end",
        anchorEl: anchorEl,
      }}
    />
  );
};

export default DateFormInput;
